import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles, teamAdmin } from '../../constants/appConstants';
import PageLoader from '../loaders/pageLoader';
import { rootLoader } from '../loaders/rootLoader';
import { teamsCardsLoader } from '../loaders/team/teamsCardsLoader';
import { teamsCodingLoader } from '../loaders/team/teamsCodingLoader';
import { teamsOverviewLoader } from '../loaders/team/teamsOverviewLoader';
import { teamsPeopleLoader } from '../loaders/team/teamsPeopleLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../queryClient';

const TeamOverview = lazy(() => import('../../components/pages/teamSettings/overview'));
const TeamCards = lazy(() => import('../../components/pages/teamSettings/cards'));
const TeamPeople = lazy(() => import('../../components/pages/teamSettings/people'));
const TeamCoding = lazy(() => import('../../components/pages/teamSettings/accountingCodes'));

const teamPath = '/team' as const;

export const teamRoutes = {
	path: teamPath,
	element: <Outlet />,
	children: [
		{
			path: 'overview',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin]}>
					<Suspense fallback={<PageLoader />}>
						<TeamOverview />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, overviewData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					teamsOverviewLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...overviewData,
				};
			},
		},
		{
			path: 'cards',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin]}>
					{' '}
					<Suspense fallback={<PageLoader />}>
						<TeamCards />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, teamData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					teamsCardsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...teamData,
				};
			},
		},
		{
			path: 'people',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin]}>
					{' '}
					<Suspense fallback={<PageLoader />}>
						<TeamPeople />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, teamData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					teamsPeopleLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...teamData,
				};
			},
		},
		{
			path: 'coding',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin]}>
					{' '}
					<Suspense fallback={<PageLoader />}>
						<TeamCoding />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, teamData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					teamsCodingLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...teamData,
				};
			},
		},
	],
};
